import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden border-t border-pink-200" data-id="element-94">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-pink-100 blur-[150px] pointer-events-none" data-id="element-95" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-97">
          <h2 className="font-display text-4xl md:text-6xl font-black mb-6 flex items-center justify-center gap-3 text-gray-900" data-id="element-98">
            <span data-id="element-99">🔥</span> EL PRÓXIMO MES PUEDE SER DISTINTO
          </h2>
          <p className="text-xl md:text-2xl text-gray-500" data-id="element-100">
            O podés seguir igual.
          </p>
          <p className="text-2xl md:text-3xl font-bold text-gray-900 mt-2" data-id="element-101">
            La decisión es tuya.
          </p>
        </motion.div>

        <div className="bg-brand-card border border-pink-200 rounded-3xl p-8 md:p-12 mb-12 max-w-2xl mx-auto shadow-lg" data-id="element-102">
          <div className="inline-flex items-center gap-2 text-brand-danger font-bold bg-red-50 px-4 py-1.5 rounded-full text-sm mb-8" data-id="element-103">
            <span data-id="element-104">⏰</span> OFERTA ACTIVA
          </div>

          <div className="space-y-6 mb-10 text-left" data-id="element-105">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 p-4 rounded-xl bg-pink-50/80 border border-pink-200" data-id="element-106">
              <div className="flex items-center gap-2 font-bold text-lg text-gray-900" data-id="element-107">
                <span data-id="element-108">📘</span> SISTEMA FITNESS COMPLETO
              </div>
              <div className="text-xl font-bold text-gray-600" data-id="element-109">
                👉 $19.990 ARS
              </div>
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 p-4 rounded-xl bg-pink-100 border border-pink-300 relative" data-id="element-110">
              <div className="absolute -top-3 -right-2 bg-brand-accent text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-111">
                RECOMENDADO
              </div>
              <div className="flex items-center gap-2 font-bold text-lg text-brand-accent" data-id="element-112">
                <span data-id="element-113">🏆</span> SISTEMA + PLAN PERSONALIZADO
              </div>
              <div className="text-2xl font-black text-gray-900" data-id="element-114">
                👉 $27.990 ARS
              </div>
            </div>
          </div>

          <a href="https://checkout.cmdigitalpro.online/cart/54037972091164:1" target="_blank" rel="noopener noreferrer" className="w-full block bg-brand-accent hover:bg-brand-accentHover text-white font-black text-xl md:text-2xl py-6 px-8 rounded-xl text-center transition-all transform hover:scale-105 shadow-[0_0_40px_rgba(233,30,140,0.4)] mb-4" data-id="element-115">
            QUIERO EMPEZAR AHORA
          </a>
          <div className="flex flex-col sm:flex-row gap-3 w-full" data-id="element-116">
            <a href="https://checkout.cmdigitalpro.online/cart/54037970682140:1" target="_blank" rel="noopener noreferrer" className="flex-1 block bg-pink-100 hover:bg-pink-200 text-gray-900 font-bold text-sm py-3 px-4 rounded-xl text-center transition-colors border border-pink-300" data-id="element-117">
              📘 Sistema Completo — $19.990
            </a>
            <a href="https://checkout.cmdigitalpro.online/cart/54037972091164:1" target="_blank" rel="noopener noreferrer" className="flex-1 block bg-brand-accent/10 hover:bg-brand-accent/20 text-brand-accent font-bold text-sm py-3 px-4 rounded-xl text-center transition-colors border border-brand-accent/30" data-id="element-118">
              🏆 Sistema + Plan — $27.990
            </a>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-gray-500 font-medium" data-id="element-119">
          <div className="flex items-center gap-2" data-id="element-120">
            <Lock size={20} className="text-gray-400" data-id="element-121" />
            <span data-id="element-122">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-123">
            <span className="text-xl" data-id="element-124">⚡</span>
            <span data-id="element-125">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-126">
            <ShieldCheck size={20} className="text-brand-success" data-id="element-127" />
            <span data-id="element-128">Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}